import React, { Fragment } from 'react';
import { Switch } from 'react-router-dom';

import { StateModel } from '../../redux/store';
import { connect } from 'react-redux';

import PublicRoute from './PublicRoute';
import Tracktrace from '../../layouts/Tracktrace';

export const Routes = () => {
  return (
    <Fragment>
      <Switch>
        <PublicRoute exact path='/' layout={Tracktrace} />
        <PublicRoute exact path='/sendungsverfolgung' layout={Tracktrace} />
      </Switch>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({});

export default connect(mapStateToProps, {})(Routes);
